export default {
  name: 'Article list section - 7',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: '',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"},{"article-title":"Article 3","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"#","button-style":"default","button-background-color":"var(--primary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/luca-bravo-A-fubu9QJxE-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '121px',
    'padding-bottom': '121px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit',
    'article-title-color': 'var(--text-dark-color)',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h4',
    'article-introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'center',
    'article-columns': '3',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'var(--background-color)',
    'content-box-padding': '50px',
    'content-box-opacity': '1',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
